/* Past het niet naast elkaar (smalle telefoon, lange labels), dan loopt de baan door op een
   tweede regel in plaats van de pagina breder te maken (review visual-ux w4, Soort kamer). */
.group {
  display: inline-flex;
  flex-wrap: wrap;
  max-width: 100%;
  gap: 2px;
  padding: 4px;
  border-radius: var(--b-radius-pill);
  background: var(--surface-sunken);
}

.group > .segment {
  flex: 1 1 auto;
}

.block {
  display: flex;
  width: 100%;
}

.block .segment {
  flex: 1 1 0;
}

.segment {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: var(--touch-min);
  padding: 0 var(--space-3);
  border: 0;
  border-radius: var(--radius-pill);
  background: transparent;
  color: var(--text-muted);
  font: inherit;
  font-size: var(--text-sm);
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  max-width: 100%;
  transition:
    background-color var(--dur) var(--ease-out),
    color var(--dur) var(--ease-out);
}

.segment:hover {
  color: var(--text);
}

.segment:focus-visible {
  outline: 3px solid var(--focus-ring);
  outline-offset: 1px;
}

.checked {
  background: var(--surface-panel);
  color: var(--text);
  box-shadow: var(--shadow-1);
}

.small .segment {
  min-height: var(--touch-min);
  padding: 0 var(--space-2);
  font-size: var(--b-text-meta);
}
